import * as PropTypes from "prop-types"
import styled from "styled-components"
import Icon from "../icons/icon"
import { Picture } from "../icons/picture"

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.paleGray}4D;
  height: ${({ h }) => h}px;
  width: ${({ w }) => (w ? `${w}px` : `100%`)};
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${({ theme }) => theme.breakpoints.sm} {
    ${({ rH }) => (rH.sm ? `height: ${rH.sm};` : "")}
  }
  @media ${({ theme }) => theme.breakpoints.md} {
    ${({ rH }) => (rH.md ? `height: ${rH.md};` : "")}
  }
  @media ${({ theme }) => theme.breakpoints.lg} {
    ${({ rH }) => (rH.lg ? `height: ${rH.lg};` : "")}
  }
  @media ${({ theme }) => theme.breakpoints.xl} {
    ${({ rH }) => (rH.xl ? `height: ${rH.xl};` : "")}
  }
`

export default function ImagePlaceholder(props) {
  const { height, width, responsiveHeight } = props
  return (
    <Wrapper h={height} w={width} rH={responsiveHeight}>
      <Icon Icon={Picture} color="gray" size={height < 50 ? "xs" : "md"} />
    </Wrapper>
  )
}

ImagePlaceholder.defaultProps = {
  height: 32,
  width: null,
  responsiveHeight: {}
}

ImagePlaceholder.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  responsiveHeight: PropTypes.object
}
